define('models/accounts/accounttransaction_collection',["backbone",
        "models/accounts/accounttransaction"
], function (Backbone, TransactionItem) {
    var TransactionList = Backbone.Collection.extend({
        url: function (pn,startdate,enddate) {
            var url = pf.consumerURL + "/Accounts/TX"
            if (pn != null) {
                url += "?pn=" + pn;
            }
            else {

                url += "?pn=" + 1;
            }
            if (startdate != null)
            {
                url += "&startdate=" + startdate;
            }
            if (enddate != null)
            {
                url += "&enddate=" + enddate;
            }
            return url;
        },
        initialize: function (options) {
            options = options || {};

            thiszAGID = options.AGID;
            this.PN = options.PN;
        },
        model: TransactionItem
    });
    return TransactionList;
});
